import { JsonObject, JsonProperty } from 'json2typescript';
import { Lawyer, LawyerLite } from 'src/app/shared/models/lawyers/lawyer';

export enum UserRole {
    ADMIN = 1,
    DATA_ENTRY = 2,
    EMPLOYEE = 3,
    ACCOUNTING = 4,
    LAWYER = 5
}


@JsonObject('User')
export class User {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('email', String, true)
    email = null;

    @JsonProperty('password', String, true)
    password = null;

    @JsonProperty('username', String, true)
    username = null;

    @JsonProperty('name', String, true)
    name = '';

    @JsonProperty('phone_number', String, true)
    phone = '';

    @JsonProperty('role', Number, true)
    role: UserRole = null;

    @JsonProperty('is_staff', Boolean, true)
    isStaff = false;

    @JsonProperty('is_active', Boolean, true)
    isActive = true;

    @JsonProperty('is_superuser', Boolean, true)
    isSuperUser = false;

    @JsonProperty('is_online', Boolean, true)
    isOnline = false;

    @JsonProperty('date_joined', String, true)
    dateJoined = null;

    @JsonProperty('last_login', String, true)
    lastLogin = null;

    @JsonProperty('profile_img', String, true)
    profileImg = null;

    @JsonProperty('lawyer_id', Number, true)
    lawyerId = null;

    @JsonProperty('lawyer', LawyerLite, true)
    lawyer = null;

    @JsonProperty('can_edit_timesheets', Boolean, true)
    canEditTimesheets = null;

    get firstName() {
        return this.name.split(' ')[0];
    }

    get isAdmin() {
        return UserRole.ADMIN === this.role;
    }

    get isLawyer() {
        return UserRole.LAWYER === this.role;
    }
}

